import type { WorkspaceAppManifest } from './workspaceManifest';

export const APP_MANIFEST = {
    appId: 'accounting-suite',
    permissionsPrefix: 'accounting',
    displayName: 'Accounting',

    navSections: [
        { key: 'dashboard',     label: 'Dashboard',     route: '/accounting/dashboard' },
        { key: 'customers',     label: 'Customers',     route: '/accounting/customers' },
        { key: 'transaction',   label: 'Transaction',   route: '/accounting/transaction' },
        { key: 'accounting',    label: 'Accounting',    route: '/accounting/accounting' },
        { key: 'reporting',     label: 'Reporting',     route: '/accounting/reporting' },
        { key: 'configuration', label: 'Configuration', route: '/accounting/configuration' },
    ],

    resources: [
        {
            key: 'customers',
            label: 'Customers',
            navSection: 'customers',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'IsActive', operators: ['eq'] },
            ],
        },
        {
            key: 'glJournalVouchers',
            label: 'Journal vouchers',
            navSection: 'accounting',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        {
            key: 'vendorBills',
            label: 'Bills',
            navSection: 'transaction',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        {
            key: 'customerInvoices',
            label: 'Invoices',
            navSection: 'transaction',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'Status', operators: ['eq', 'neq', 'in', 'notin'] },
            ],
        },
        { key: 'vendorBillPosting',      label: 'Bills — post/unpost',    navSection: 'transaction' },
        { key: 'customerInvoicePosting', label: 'Invoices — post/unpost', navSection: 'transaction' },
        { key: 'bankPayments',      label: 'Bank payments',      navSection: 'transaction' },
        { key: 'cashPayments',      label: 'Cash payments',      navSection: 'transaction' },
        { key: 'bankReceipts',      label: 'Bank receipts',      navSection: 'transaction' },
        { key: 'cashReceipts',      label: 'Cash receipts',      navSection: 'transaction' },
        { key: 'bankPaymentsPosting',      label: 'Bank payments — unpost',      navSection: 'transaction' },
        { key: 'cashPaymentsPosting',      label: 'Cash payments — unpost',      navSection: 'transaction' },
        { key: 'bankReceiptsPosting',      label: 'Bank receipts — unpost',      navSection: 'transaction' },
        { key: 'cashReceiptsPosting',      label: 'Cash receipts — unpost',      navSection: 'transaction' },
        { key: 'glJournalVouchersPosting', label: 'Journal vouchers — unpost',   navSection: 'transaction' },
        { key: 'trialBalance',   label: 'Trial balance',  navSection: 'reporting' },
        { key: 'generalLedger',  label: 'General ledger', navSection: 'reporting' },
        { key: 'partiesLedger',  label: 'Parties ledger', navSection: 'reporting' },
        { key: 'taxLedger',      label: 'Tax ledger',     navSection: 'reporting' },
        { key: 'profitLoss',     label: 'Profit & Loss',  navSection: 'reporting' },
        {
            key: 'glChartAccounts',
            label: 'Chart of accounts',
            navSection: 'configuration',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
                { field: 'IsActive', operators: ['eq'] },
            ],
        },
        {
            key: 'glAccountGroups',
            label: 'Account groups',
            navSection: 'configuration',
            recordRuleFields: [
                { field: 'CompanyId', operators: ['eq'] },
            ],
        },
        { key: 'glVoucherTypes',     label: 'Voucher types',    navSection: 'configuration' },
        { key: 'glAccountTypes',     label: 'GL account types', navSection: 'configuration' },
        { key: 'vendors',            label: 'Vendors',          navSection: 'configuration' },
        { key: 'genBankInformation', label: 'Bank information', navSection: 'configuration' },
        { key: 'genCashInformation', label: 'Cash information', navSection: 'configuration' },
    ],
} satisfies WorkspaceAppManifest;
